var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelegramIcoBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0158 1.89929L10.2049 10.3855C10.0682 10.9843 9.71203 11.1334 9.20584 10.8515L6.4464 8.83095L5.11512 10.1036C4.96767 10.2501 4.84466 10.3723 4.56049 10.3723L4.75894 7.58005L9.87276 2.98833C10.0952 2.79156 9.82433 2.68211 9.5273 2.8793L3.2052 6.83514L0.483482 5.98843C-0.108438 5.80487 -0.119153 5.40025 0.606924 5.11788L11.2525 1.04236C11.7454 0.858792 12.1766 1.15139 12.0158 1.89971V1.89929Z",
    fill: "#50A4E0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramIcoBlue);
export default __webpack_public_path__ + "static/media/telegram-ico-blue.dc767867a9eec38270f65e7f728531c1.svg";
export { ForwardRef as ReactComponent };